import { createAsyncAction, createStandardAction } from 'typesafe-actions'
import {
  RoleListReq,
  RoleListRes,
  CreateRoleReq,
  ActionRoleRes,
  UpdateRoleReq,
  DeleteRoleReq,
  RoleDetailReq,
  RoleDetailRes,
} from './types'

export const getRoleListAction = createAsyncAction(
  'PERMISSION/GET_PERMISSION_LIST_REQ',
  'PERMISSION/GET_PERMISSION_LIST_SUCCESS',
  'PERMISSION/GET_PERMISSION_LIST_FAILURE',
)<RoleListReq, RoleListRes, Error>()

export const getRoleDetailAction = createAsyncAction(
  'PERMISSION/GET_PERMISSION_DETAIL_REQ',
  'PERMISSION/GET_PERMISSION_DETAIL_SUCCESS',
  'PERMISSION/GET_PERMISSION_DETAIL_FAILURE',
)<RoleDetailReq, RoleDetailRes, Error>()

export const createRoleAction = createAsyncAction(
  'PERMISSION/CREATE_PERMISSION_REQ',
  'PERMISSION/CREATE_PERMISSION_SUCCESS',
  'PERMISSION/CREATE_PERMISSION_FAILURE',
)<CreateRoleReq, ActionRoleRes, Error>()

export const updateRoleAction = createAsyncAction(
  'PERMISSION/UPDATE_PERMISSION_REQ',
  'PERMISSION/UPDATE_PERMISSION_SUCCESS',
  'PERMISSION/UPDATE_PERMISSION_FAILURE',
)<UpdateRoleReq, ActionRoleRes, Error>()

export const deleteRoleAction = createAsyncAction(
  'PERMISSION/DELETE_PERMISSION_REQ',
  'PERMISSION/DELETE_PERMISSION_SUCCESS',
  'PERMISSION/DELETE_PERMISSION_FAILURE',
)<DeleteRoleReq, ActionRoleRes, Error>()

export const getAllRoleListAction = createAsyncAction(
  'PERMISSION/GET_ALL_PERMISSION_LIST_REQ',
  'PERMISSION/GET_ALL_PERMISSION_LIST_SUCCESS',
  'PERMISSION/GET_ALL_PERMISSION_LIST_FAILURE',
)<RoleListReq, RoleListRes, Error>()

export const clearEventAction = createStandardAction('PERMISSION/CLEAR_EVENT')<void>()
